export const DEMO_SCRAPE_WAIT_SECONDS = 30;
export const DEMO_SCRAPE_WAIT_MS = DEMO_SCRAPE_WAIT_SECONDS * 1000;

export const waitForDemoScrape = (ms = DEMO_SCRAPE_WAIT_MS) => (
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  })
);
